var section = 'fx_2d2fb1e5_1b8bnvj0';

export { section };
//# sourceMappingURL=section.vanilla.mjs.map
